var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":_vm.id + '__fb_uploader__'}},[_c('Uploader',{ref:"filePond",attrs:{"server":{
      process: _vm.tryToUpload,
    },"label-idle":_vm.placeholder,"label-file-processing-error":_vm.errorMessage,"accepted-file-types":_vm.acceptedFileTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }